import React from 'react';
import PropTypes from 'prop-types';

import { ViewerPrimaryColorUserStyle } from '../../../UserCustomization';

export function FacilityFeatures({
  property,
  type,
}) {
  const { about } = property.additionalDetails;
  const sectionHeader = type === 'sites' ? 'Property Description' : 'Facility Features';

  return (
    <section>
      <ViewerPrimaryColorUserStyle domStyle="color">
        <h4 className="section-title">{sectionHeader}</h4>
      </ViewerPrimaryColorUserStyle>
      <div className="section-body">
        { about.description }
        {
          about.description === '' &&
          about.description2
        }
        {
          about.description === '' &&
          about.desciption2 === '' &&
          about.description3
        }
      </div>
    </section>
  );
}

FacilityFeatures.propTypes = {
  property: PropTypes.object.isRequired,
  type: PropTypes.string,
};

export default FacilityFeatures;



// WEBPACK FOOTER //
// ./src/components/PropertyDetail/PropertyDetailOverview/OverviewSections/FacilityFeatures.js